module.exports = __webpack_public_path__ + "a3b5eb2fd4be679210afd738fcf8edb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/8.jpg
// module id = 231
// module chunks = 0